import { render, staticRenderFns } from "./TheAdminPageModal.vue?vue&type=template&id=a789fdc8&"
import script from "./TheAdminPageModal.vue?vue&type=script&lang=js&"
export * from "./TheAdminPageModal.vue?vue&type=script&lang=js&"
import style0 from "./TheAdminPageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a789fdc8')) {
      api.createRecord('a789fdc8', component.options)
    } else {
      api.reload('a789fdc8', component.options)
    }
    module.hot.accept("./TheAdminPageModal.vue?vue&type=template&id=a789fdc8&", function () {
      api.rerender('a789fdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/TheAdminPageModal.vue"
export default component.exports